/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';


export const getErrors = createSelector(
  [state => state.errors],
  errors => errors,
);
